import { UpdateReturnWorkflowDto } from "../generated/schema.ts";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { invalidateAllReturnWorkflowsKey } from "./use-get-all-return-workflows.ts";
import { useApiMutation } from "./use-api-mutation";


export default function useUpdateReturnWorkflow(shopId: string) {
  return useApiMutation(
    "patch",
    "/shops/{shopId}/return-workflows/{workflowId}",
    {
      meta: {
        success: {
          title: "workflows.editor.update.success.title",
          message: "workflows.editor.update.success.message",
        },
        error: {
          title: "workflows.editor.update.error.title",
          message: "workflows.editor.update.error.message",
        },
        invalidatesQuery: [
          invalidateAllReturnWorkflowsKey(shopId),
          invalidateAllShopEmailTemplatesKey(shopId),
        ],
      },
      mapVariables: ({ requestBody, id }: { requestBody: UpdateReturnWorkflowDto, id: string }) => ({
        params: { path: { shopId: shopId, workflowId: id } },
        body: requestBody,
      }),
    },
  );
}
